// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import OrderInformation from './orderInformation';
import React from 'react';

function OrderInformationPage () {

    return (
        <AuthenticatedPage className="atp-page atp-order-information-page">
            <OrderInformation />
        </AuthenticatedPage>
    );

}
OrderInformationPage.displayNAme = 'OrderInformationPage';

export default OrderInformationPage;
